export default __webpack_public_path__ + "locales/lv/DowngradePlanDialog.json?hash=8ca64fd997a8c7532f020c3a39b32c85";